import { render, staticRenderFns } from "./notAssigned_mr.vue?vue&type=template&id=5bf6732c&"
import script from "./notAssigned_mr.vue?vue&type=script&lang=js&"
export * from "./notAssigned_mr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports